import React from 'react'
import GoogleMapSearch from '../../../../../common/components/google-map-search'
import { InputContainer } from '../../../../../common/components/form/form.module'

export default function ModalLeadComponent({ handleEstimateleadSubmit, selectedEstimateItem, dropLocations, pickupLocations, setDropLocations, setPickupLocations,
    handleInnerFormChange }: any) {


    return (

        <div className=" w-full p-2 bg-white">
            <h1 className="text-xl font-bold mb-4 text-center">Edit Details</h1>
            <div className=' grid md:grid-cols-2 lg:grid-cols-3 gap-4'>

                <div className="">
                    <div className='font-semibold line-clamp-2 mb-2 text-slate-800'>Pickup Address</div>
                    <GoogleMapSearch
                        setLocation={setPickupLocations}
                        location={pickupLocations}
                        placeholder="Search Address" />
                </div>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedEstimateItem?.Name}
                />
                <InputContainer
                    isRequired
                    label="PhoneNumber"
                    name="PhoneNumber"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'PhoneNumber'

                        )

                    }}
                    minLength={10}
                    type="number"
                    value={selectedEstimateItem?.PhoneNumber}
                />
                <div className=" ">
                    <div className='font-semibold line-clamp-2 mb-2 text-slate-800'>Pickup Address</div>
                    <GoogleMapSearch
                        setLocation={setDropLocations}
                        location={dropLocations}
                        placeholder="Search Address" />
                </div>

                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'name'

                        )
                    }}
                    type="text"
                    value={selectedEstimateItem?.name}
                />
                <InputContainer
                    isRequired
                    label="PhoneNumber"
                    name="PhoneNumber"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'toPhoneNumber'

                        )

                    }}
                    minLength={10}
                    type="number"
                    value={selectedEstimateItem?.toPhoneNumber}
                />
                <div className="text-center mt-4">
                    <div className="flex justify-center gap-4">

                        <button
                            onClick={handleEstimateleadSubmit}
                            type="button"
                            className="bg-primary text-light font-medium px-6 py-2 rounded">
                            Save
                        </button>
                    </div>
                </div>

            </div>


        </div>

    )
}